import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { Calendar, Edit3 } from '@/components/ui/icons'
import { SPACING } from '@/lib/theme/tokens'

/** The two everyday host tasks, in the same order at every vehicle entry point. */
export function HostVehicleActions({
  onEdit,
  onCalendar,
  index,
}: {
  onEdit: () => void
  onCalendar: () => void
  index: number
}) {
  const { t } = useTranslation()
  return (
    <View style={{ flexDirection: 'row', gap: SPACING.sm, padding: SPACING.sm }}>
      <Button
        title={t('common.edit')}
        accessibilityLabel={t('hosting.edit_vehicle')}
        variant="secondary"
        size="sm"
        icon={<Edit3 size={16} />}
        onPress={onEdit}
        testID={`listings.edit-${index}`}
        style={{ flex: 0.8, paddingHorizontal: SPACING.xs }}
      />
      <Button
        title={t('calendar.block_dates')}
        variant="secondary"
        size="sm"
        icon={<Calendar size={16} />}
        onPress={onCalendar}
        testID={`listings.calendar-${index}`}
        style={{ flex: 1.2, paddingHorizontal: SPACING.xs }}
      />
    </View>
  )
}
